import { usePermission } from '../../hooks/usePermission';

/**
 * "＋ New …" beside a dropdown whose choices come from a setup list.
 *
 * Every dropdown fed by a master has to say where that master is made, or an
 * empty one is a dead end: the store-location box on a purchase said "No
 * locations set up yet" and nothing else. It opens in a new tab so a
 * half-entered purchase or product is not lost, and the dropdown picks the new
 * entry up when this tab is looked at again.
 */
export function MasterLink({
  to,
  label,
  permission = 'master.manage',
}: {
  to: string;
  label: string;
  permission?: string;
}) {
  const { can } = usePermission();
  if (!can(permission)) return null;
  return (
    <a
      href={to}
      target="_blank"
      rel="noreferrer"
      className="mt-1 inline-block text-2xs text-gold-700 underline"
      onClick={(e) => e.stopPropagation()}
    >
      ＋ {label}
    </a>
  );
}
